// One-shot convenience for vanilla JS: create a pool, run the work, dispose it —
// no lifecycle to manage. Ideal for a single batch of tasks.
//
//   const results = await parallel(heavy, items)
//   const doubled = await parallel((n) => n * 2, [1, 2, 3], { threads: 4 })
import { pool, type PoolOptions, type CallOptions } from './pool.ts'

export async function parallel<A, R>(
  task: (arg: A) => R | Promise<R>,
  items: readonly A[],
  opts: PoolOptions & CallOptions = {}
): Promise<R[]> {
  const { signal, timeout, retries, ...poolOpts } = opts
  const p = pool<A, R>(task, poolOpts)
  try {
    return await p.map(items, { signal, timeout, retries })
  } finally {
    await p.dispose()
  }
}
